<template>
  <Container title="优惠券发行" :returnBtn="false" :addBtn="false">
    <div style="padding: 20px;">
      <el-card shadow="hover" class="coupon-form-card">
        <template #header>
          <div class="card-header">
            <span>批量生成优惠券</span>
          </div>
        </template>
        <el-form :model="couponForm" label-width="120px" class="coupon-form">
          <el-form-item label="生成个数" required>
            <el-input v-model.number="couponForm.count" placeholder="请输入生成个数" type="number" min="1" max="1000" />
          </el-form-item>
          <el-form-item label="优惠券名称" required>
            <el-input v-model="couponForm.name" placeholder="请输入优惠券名称" />
          </el-form-item>
          <el-form-item label="金额" required>
            <el-input v-model.number="couponForm.money" placeholder="请输入优惠券金额" type="number" min="0.01" step="0.01" />
          </el-form-item>
          <el-form-item label="可使用金额" required>
            <el-input v-model.number="couponForm.minmoney" placeholder="请输入满多少可使用" type="number" min="0" step="0.01" />
          </el-form-item>
          <el-form-item label="发行时间" required>
            <el-date-picker
              v-model="couponForm.createtime"
              type="datetime"
              placeholder="选择发行时间"
              format="YYYY年MM月DD日 HH:mm:ss"
              value-format="YYYY-MM-DD HH:mm:ss"
            />
          </el-form-item>
          <el-form-item label="到期时间" required>
            <el-date-picker
              v-model="couponForm.endtime"
              type="datetime"
              placeholder="选择到期时间"
              format="YYYY年MM月DD日 HH:mm:ss"
              value-format="YYYY-MM-DD HH:mm:ss"
            />
          </el-form-item>
          <el-form-item label="是否全员显示" required>
            <el-radio-group v-model="couponForm.showvip">
              <el-radio value="是">是</el-radio>
              <el-radio value="否">否</el-radio>
            </el-radio-group>
          </el-form-item>
          <el-form-item>
            <el-button type="primary" @click="generateCoupons" :loading="loading">生成优惠券</el-button>
          </el-form-item>
        </el-form>
      </el-card>
    </div>
  </Container>
</template>

<script>
import Container from "../../components/container/Container";
import moment from 'moment';

export default {
  components: {
    Container
  },
  data() {
    return {
      couponForm: {
        count: 1,
        name: '',
        money: 0,
        minmoney: 0,
        createtime: moment().format('YYYY-MM-DD HH:mm:ss'),
        endtime: '',
        showvip: '是'
      },
      loading: false
    };
  },
  methods: {
    async generateCoupons() {
      if (!this.couponForm.count || !this.couponForm.name || !this.couponForm.money || !this.couponForm.endtime) {
        this.$message.warning('请填写完整的优惠券信息');
        return;
      }

      this.loading = true;
      try {
        const response = await this.$api.feng.orpost(`feng/feng/coupon/generate`, {
          count: this.couponForm.count,
          name: this.couponForm.name,
          money: this.couponForm.money * 100,
          minmoney: this.couponForm.minmoney * 100,
          createtime: new Date(this.couponForm.createtime).getTime(),
          endtime: new Date(this.couponForm.endtime).getTime(),
          showvip: this.couponForm.showvip
        });

        if (response.success) {
          this.$message.success('优惠券生成成功');
          this.couponForm = {
            count: 1,
            name: '',
            money: 0,
            minmoney: 0,
            createtime: moment().format('YYYY-MM-DD HH:mm:ss'),
            endtime: '',
            showvip: '是'
          };
        } else {
          this.$message.error(response.message || '优惠券生成失败');
        }
      } catch (error) {
        console.error('生成优惠券失败:', error);
        this.$message.error('生成失败');
      } finally {
        this.loading = false;
      }
    }
  }
};
</script>

<style scoped>
.coupon-form-card {
  margin-bottom: 20px;
}

.coupon-form {
  margin-top: 20px;
}

.card-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
}
</style>